export const USER_BOOTSTRAP_REQUESTED = 'USER_BOOTSTRAP_REQUESTED'
export const USER_BOOTSTRAP_RECEIVED = 'USER_BOOTSTRAP_RECEIVED'
